// initiate context to be called in components
import React from "react";

export const AppContext = React.createContext();
